import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    LessonService,
    LessonPopupService,
    LessonComponent,
    LessonNoAuthComponent,
    LessonDetailComponent,
    LessonDialogComponent,
    LessonPopupComponent,
    LessonDeletePopupComponent,
    LessonConfirmCancelPopupComponent,
    LessonSendNotificationPopupComponent,
    LessonSendNotificationDialogComponent,
    LessonConfirmExecutedPopupComponent,
    LessonBulkCreatePopupComponent,
    LessonBulkCreateDialogComponent,
    LessonDeleteDialogComponent,
    LessonConfirmCancelDialogComponent,
    LessonConfirmExecutedDialogComponent,
    lessonRoute,
    lessonPopupRoute,
    LessonResolvePagingParams,
    LessonChoosePaymentMethodDialogComponent,
    LessonChoosePaymentMethodPopupComponent
} from './';

let ENTITY_STATES = [
    ...lessonRoute,
    ...lessonPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        LessonComponent,
        LessonNoAuthComponent,
        LessonDetailComponent,
        LessonDialogComponent,
        LessonDeleteDialogComponent,
        LessonConfirmCancelDialogComponent,
        LessonSendNotificationDialogComponent,
        LessonSendNotificationPopupComponent,
        LessonConfirmExecutedDialogComponent,
        LessonPopupComponent,
        LessonDeletePopupComponent,
        LessonConfirmCancelPopupComponent,
        LessonConfirmExecutedPopupComponent,
        LessonBulkCreatePopupComponent,
        LessonBulkCreateDialogComponent,
        LessonChoosePaymentMethodDialogComponent,
        LessonChoosePaymentMethodPopupComponent
    ],
    entryComponents: [
        LessonComponent,
        LessonNoAuthComponent,
        LessonDialogComponent,
        LessonPopupComponent,
        LessonDeleteDialogComponent,
        LessonDeletePopupComponent,
        LessonConfirmCancelDialogComponent,
        LessonConfirmCancelPopupComponent,
        LessonSendNotificationDialogComponent,
        LessonSendNotificationPopupComponent,
        LessonConfirmExecutedDialogComponent,
        LessonConfirmExecutedPopupComponent,
        LessonBulkCreatePopupComponent,
        LessonBulkCreateDialogComponent,
        LessonChoosePaymentMethodDialogComponent,
        LessonChoosePaymentMethodPopupComponent
    ],
    providers: [
        LessonService,
        LessonPopupService,
        LessonResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiLessonModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.module.ts